import _isEmpty from 'lodash/isEmpty';

import {
  DEFAULT_PLACEHOLDER,
  DEFAULT_SEO_PAGE_DESCRIPTION_PROMPT_CLASS,
  DESCRIPTION_TOO_LONG_MESSAGE,
  DESCRIPTION_TOO_SHORT_MESSAGE,
  MAX_INPUT_LENGTH_WARNING,
  MAX_LENGTH,
  MIN_INPUT_LENGTH_WARNING,
} from './SeoDescription.constants';
import API from '../../../../../../../libs/api';
import {
  getDefaultWritingActions,
  getWritingAssistantActions,
} from '../../../../../content/services/prompts';

export async function getAiGeneratedSeoDescription(
  businessId,
  businessType,
  params = {},
  { promptClass = DEFAULT_SEO_PAGE_DESCRIPTION_PROMPT_CLASS } = {},
) {
  return API.textCompletion(businessType, businessId, promptClass, params);
}

export function getWarningMessage(
  description,
  {
    maxInputLengthWarning = MAX_INPUT_LENGTH_WARNING,
    minInputLengthWarning = MIN_INPUT_LENGTH_WARNING,
  } = {},
) {
  if (_isEmpty(description)) {
    return '';
  }
  if (description.length > maxInputLengthWarning) {
    return `${DESCRIPTION_TOO_LONG_MESSAGE} Max length is ${maxInputLengthWarning} characters.`;
  }
  if (description.length < minInputLengthWarning) {
    return `${DESCRIPTION_TOO_SHORT_MESSAGE} Min length is ${minInputLengthWarning} characters.`;
  }
  return '';
}

export function getWritingSections({ onMakeSuggestion, placeholder = '', onWriteDefault } = {}) {
  let finalActions = [...getWritingAssistantActions({ onMakeSuggestion })];
  if (
    !_isEmpty(placeholder) &&
    placeholder.length < MAX_LENGTH &&
    placeholder !== DEFAULT_PLACEHOLDER
  ) {
    finalActions = [...getDefaultWritingActions({ onWriteDefault }), ...finalActions];
  }
  return finalActions;
}
